import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.backWallTypeState || initialState;

export const selectBackWallTypeLoading = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.loading
);

export const selectBackWallTypeList = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.list
);

export const selectBackWallTypeMeta = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.meta
);

export const selectBackWallTypePage = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.page
);

export const selectBackWallTypePerPage = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.isAddModalOpen
);

export const selectBackWallTypeForm = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.form
);

export const selectCanSubmitBackWallType = createSelector(
  [selectBackWallTypeForm],
  (form) => Object.values(form).every((value) => Boolean(value.trim()))
);

export const selectBackWallTypeSaving = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.saving
);

export const selectBackWallTypeError = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.error
);

export const selectBackWallTypeDetail = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.detail
);

export const selectBackWallTypeDetailLoading = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.detailLoading
);

export const selectBackWallTypeDetailError = createSelector(
  [selectDomain],
  (backWallTypeState) => backWallTypeState.detailError
);
